import React from 'react';
import { Navigate, Route, Routes, useLocation, useSearchParams } from 'react-router-dom';
import FamilyLayout from '../../components/family/FamilyLayout';
import FamilyHome from './FamilyHome';
import FamilyProgram from './FamilyProgram';
import FamilyEventPage from './FamilyEventPage';
import FamilyMe from './FamilyMe';
import FamilyPlayerPage from './FamilyPlayerPage';
import FamilySubPage from './FamilySubPage';
import Board from '../Board';
import ParentFeesView from '../../components/membershipFees/ParentFeesView';
import Documents from '../Documents';
import Profile from '../Profile';
import Help from '../Help';
import AcceptInvite from '../AcceptInvite';

/** A régi /events?event=42 hivatkozás az esemény oldalára visz, egyébként a programra. */
const EventsRedirect: React.FC = () => {
  const [searchParams] = useSearchParams();
  const id = searchParams.get('event');
  return <Navigate to={id ? `/events/${id}` : '/program'} replace />;
};

/** A régi útvonalak (értesítések, levelek, könyvjelzők) a helyükre visznek. */
const Redirect: React.FC<{ to: string }> = ({ to }) => {
  const location = useLocation();
  return <Navigate to={`${to}${location.search}`} replace />;
};

/**
 * A szülők és a játékosok appja: Kezdőlap, Program, Hírek, Profil. A stáb
 * eszközei és a statisztikák itt nem érhetők el.
 */
const FamilyApp: React.FC = () => (
  <FamilyLayout>
    <Routes>
      <Route path="/" element={<FamilyHome />} />
      <Route path="/program" element={<FamilyProgram />} />
      <Route path="/events/:id" element={<FamilyEventPage />} />
      <Route path="/events" element={<EventsRedirect />} />
      <Route path="/board" element={<Board title="Hírek" subtitle={null} />} />
      <Route path="/board/:id" element={<Board title="Hírek" subtitle={null} />} />
      <Route path="/me" element={<FamilyMe />} />
      <Route path="/me/players/:id" element={<FamilyPlayerPage />} />
      <Route path="/me/fees" element={<FamilySubPage title="Tagdíj"><ParentFeesView /></FamilySubPage>} />
      <Route path="/me/documents" element={<FamilySubPage><Documents /></FamilySubPage>} />
      <Route
        path="/me/account"
        element={
          <FamilySubPage title="Fiók és értesítések">
            <Profile familyView />
          </FamilySubPage>
        }
      />
      <Route path="/help" element={<FamilySubPage><Help /></FamilySubPage>} />

      <Route path="/profile" element={<Redirect to="/me/account" />} />
      <Route path="/membership-fees" element={<Redirect to="/me/fees" />} />
      <Route path="/documents" element={<Redirect to="/me/documents" />} />
      {['/calendar', '/matches', '/travel', '/statistics', '/training-statistics', '/trainings'].map((path) => (
        <Route key={path} path={path} element={<Navigate to="/program" replace />} />
      ))}
      <Route path="/invite/:token" element={<AcceptInvite />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  </FamilyLayout>
);

export default FamilyApp;
